"use client";

import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Typography } from "../ui/typography";
import { HugeiconsIcon } from "@hugeicons/react";
import { AddIcon, MinusSignIcon } from "@hugeicons/core-free-icons";
import { cn } from "@/lib/utils";

interface CounterProps {
  label: string;
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  className?: string;
  disabled?: boolean;
}

export const Counter: React.FC<CounterProps> = ({
  label,
  value,
  onChange,
  className,
  min = 1,
  max,
  disabled = false,
}) => {
  const handleIncrement = () => {
    if (disabled || (max !== undefined && value >= max)) return;
    onChange(value + 1);
  };

  const handleDecrement = () => {
    if (disabled || value <= min) return;
    onChange(value - 1);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (disabled) return;
    const newValue = parseInt(e.target.value) || min;
    onChange(max !== undefined ? Math.min(newValue, max) : newValue);
  };

  return (
    <div
      className={cn(
        "relative flex items-center gap-2 p-5",
        className,
        disabled && "opacity-60"
      )}
    >
      <Typography variant="bodySRegular" className="ml-12">
        {label}
      </Typography>
      <Button
        // variant="outline"
        // size="icon"
        className="border rounded-[8px]! size-[26px] p-0 bg-transparent! border-primary! disabled:opacity-100 disabled:!border-black-50 text-primary disabled:text-black-200 mr-auto"
        onClick={handleIncrement}
        disabled={disabled || (max !== undefined && value >= max)}
        type="button"
      >
        <HugeiconsIcon icon={AddIcon} size={20} strokeWidth={1.5} />
      </Button>
      <Input
        type="number"
        value={value || 0}
        onChange={handleInputChange}
        className={cn(
          "p-0 w-8 h-6 text-center border-none !bg-transparent placeholder:text-gray-400 text-foreground"
        )}
        min={min}
        disabled={disabled}
      />
      <Button
        // variant="outline"
        // size="icon"
        className="border rounded-[8px]! size-[26px] bg-transparent! p-0!  border-primary! disabled:opacity-100 disabled:!border-black-50 text-primary disabled:text-black-200"
        onClick={handleDecrement}
        disabled={disabled || value <= min}
        type="button"
      >
        <HugeiconsIcon icon={MinusSignIcon} size={20} strokeWidth={1.5} />
      </Button>
    </div>
  );
};
